import { promotionsSelector } from 'dashboard/selectors'
import { TableContainer } from '@components/Table'

import Promotion from './Promotion'
import Header from './Header'
import './styles.scss'

const isPromotionValid = promotion => !!(promotion && promotion.couponCode)

const PromotionsView = ({ promotions }) => (
    <TableContainer className="container dashboard-inner-container">
        <Header />
        {promotions &&
            promotions.map((promotion, index) =>
                isPromotionValid(promotion) ? <Promotion promotion={promotion} key={index} /> : null
            )}
    </TableContainer>
)

export default compose(
    connect(
        createStructuredSelector({
            promotions: promotionsSelector,
        })
    )
)(PromotionsView)
